import { render, staticRenderFns } from "./PreLoader.vue?vue&type=template&id=2e53705c&lang=html&"
import script from "./PreLoader.vue?vue&type=script&lang=ts&"
export * from "./PreLoader.vue?vue&type=script&lang=ts&"
import style0 from "./PreLoader.vue?vue&type=style&index=0&id=2e53705c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports